export const basePath = {
  // url: "http://localhost:2000/api/",
  url: "https://students.teauportal.com/api/",
};

export const uplPath = {
  url: "https://students.teauportal.com/api/",
};
